var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "setting-btn", on: { click: _vm.openList } },
    [
      _c("img", {
        attrs: { src: require("@/assets/img/icon/setting.png"), alt: "" },
      }),
      _c("span", [_vm._v(_vm._s(_vm.$ln("設定")))]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }